import { useEffect, useState } from "react";
import { ServerDownIllustration } from "@/base-components/illustrations/server-down-illustration";
import { UpdateIllustration } from "@/base-components/illustrations/update-illustration";
import * as m from "@/paraglide/messages.js";
// Not react-icons: this component is in the entry chunk, and one icon from `react-icons/md` brings every Md icon the
// app uses along with it.
import { HistoryIcon } from "lucide-react";
import { useNetworkState } from "react-use";

import { Button } from "@cruitive/ui/button";

interface Props {
  isUpdate: boolean;
  isChunkFailure: boolean;
}

export function ErrorUpdateMessage({ isUpdate, isChunkFailure }: Props) {
  const { online: _online } = useNetworkState();
  const [online, setOnline] = useState<null | undefined | boolean>(null);

  useEffect(() => {
    if (online == null || online === undefined) {
      setOnline(_online);
    }
  }, [online, _online]);

  const [loading, setLoading] = useState(false);
  const handleUpdate = () => {
    setLoading(true);
    window.location.reload();
  };

  if (online == null) {
    return <div />;
  }

  const updated = isUpdate && online;
  const offline = isChunkFailure && !online;

  return (
    <div className="flex-center min-h-screen bg-background p-12">
      <div className="flex max-w-2xl flex-col items-center">
        {updated ? <UpdateIllustration /> : <ServerDownIllustration />}
        <h1 className="mt-10 text-center text-5xl font-bold text-foreground">
          {updated && m.cruitive_updated()}
          {!updated && m.something_went_wrong()}
        </h1>
        <p className="mt-4 text-center text-xl text-muted-foreground">
          {updated && m.cruitive_update_refresh()}
          {offline && m.error_loading_page_no_internet()}
          {!updated && !offline && m.error_displaying_page()}
        </p>
        <Button
          disabled={loading}
          onClick={handleUpdate}
          size="lg"
          className="mt-6 w-full max-w-lg text-xl"
        >
          <HistoryIcon
            className={`mr-2 h-5 w-5 ${loading && "animate-spin"}`}
          />
          {m.reload_page()}
        </Button>
      </div>
    </div>
  );
}
